import ProfileService from "@/modules/auth/Profile/ProfileService";

export default {
  namespaced: true,
  state: {
    tableData: {
      rows: [],
      loading: false,
    },
    authenticatorCreated: null,
    authenticatorModal: {
      show: false,
      loading: false,
      url: null
    },
    trustedDevices: {
      rows: [],
      loading: false
    }
  },
  actions: {
    async getTableData({commit}) {
      commit('updateTableLoading', true);
      const response = await ProfileService.getActiveSessions();
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body
        });
      }

      return response;
    },
    async getAuthenticatorData({commit}, code) {
      const  response = await ProfileService.getAuthenticatorData(code);
      if (response.success) {
        commit('updateAuthenticatorData', response.body.data);
      }
    },
    async openAuthenticatorModal({commit}, data) {
      commit('showAuthenticatorModal');
      commit('toggleAuthenticatorModalLoading', true);
      const response = await ProfileService.postAuthenticator(null);
      if (response.success) {
        commit('updateAuthenticatorUrl', response.body.data);
      }
      commit('toggleAuthenticatorModalLoading', false);
    },
    async submitAuthenticatorToken({}, code){
      return await ProfileService.postAuthenticator(code);
    },
    async hideAuthenticatorModal({commit}) {
      commit('hideAuthenticatorModal');
      commit('updateAuthenticatorUrl', null);
    },
    async removeAuthenticator(){
      return await ProfileService.removeAuthenticator();
    },
    async removeTrustedDevice({}, uuid){
      return await ProfileService.removeTrustedDevice(uuid);
    },
    async getTrustedDevices({commit}, code) {
      commit('setTrustedDevicesLoading', true)
      const  response = await ProfileService.getTrustedDevices();
      if (response.success) {
        commit('updateTrustedDevices', response.body.data || []);
      }
      commit('setTrustedDevicesLoading', false)
    },
  },
  mutations: {
    updateTableData: (state, payload) => state.tableData = {...state.tableData, ...payload},
    updateTableLoading: (state, payload) => state.tableData.loading = payload,
    updateAuthenticatorData: (state, payload) => state.authenticatorCreated = payload ? payload.created : null,
    showAuthenticatorModal: (state) => state.authenticatorModal.show = true,
    hideAuthenticatorModal: (state) => state.authenticatorModal.show = false,
    toggleAuthenticatorModalLoading: (state, payload) => state.authenticatorModal.loading = payload,
    updateAuthenticatorUrl: (state, payload) => state.authenticatorModal.url = payload ? payload.url : null,
    updateTrustedDevices: (state, payload) => state.trustedDevices.rows = [...payload],
    setTrustedDevicesLoading: (state, payload) => state.trustedDevices.loading = payload,

  }
}
